
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"contratoCatalogoConceptos"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idContrato"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contratoCatalogoConceptos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"idContrato"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idContrato"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"idContrato"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"idObra"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"idConvenioModificatorio"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"clave"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"idPadre"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"padre"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"clave"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"concepto"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tipo"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"tipo"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"concepto"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"unidad"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cantidad"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"precioUnitario"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"importe"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"reportes"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"avanceFisico"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ponderadoPartida"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"avancePonderado"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"comentarios"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"esUltimo"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"estimado"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"idEstimacion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"estimacion"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"numero"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"cantidad"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"importe"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"createdAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"orden"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"favoritos"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"idContrato"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"idConcepto"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"orden"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"createdAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"esFavorito"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":761}};
    doc.loc.source = {"body":"query contratoCatalogoConceptos($idContrato: ID!) {\n  contratoCatalogoConceptos(idContrato: $idContrato) {\n    id\n    idContrato\n    idObra\n    idConvenioModificatorio\n    clave\n    idPadre\n    padre {\n      id\n      clave\n      concepto\n      tipo\n    }\n    tipo\n    concepto\n    unidad\n    cantidad\n    precioUnitario\n    importe\n    reportes {\n      id\n      avanceFisico\n      ponderadoPartida\n      avancePonderado\n      comentarios\n      esUltimo\n    }\n    estimado {\n      id\n      idEstimacion\n      estimacion {\n        id\n        numero\n      }\n      cantidad\n      importe\n      createdAt\n      updatedAt\n    }\n    orden\n    favoritos {\n      id\n      idContrato\n      idConcepto\n      orden\n      createdAt\n      updatedAt\n    }\n    esFavorito\n  }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["contratoCatalogoConceptos"] = oneQuery(doc, "contratoCatalogoConceptos");
        
